import React from "react";
import { Navigate, useLocation } from "react-router-dom";
import { useAuth } from "@/context/AuthContext";

export default function ProtectedRoute({ children }) {
  const { user, initializing } = useAuth();
  const location = useLocation();

  if (initializing || user === null) {
    return (
      <div className="min-h-screen flex items-center justify-center bg-[#F7F9FA]" data-testid="protected-loading">
        <div className="text-[#4B5563]">Yükleniyor...</div>
      </div>
    );
  }

  if (!user) {
    return <Navigate to="/admin/login" state={{ from: location }} replace />;
  }

  return children;
}
